<div class="bg-gray-100 rounded-lg flex p-2 items-center justify-end mt-4 mb-2" *ngIf="searchable">
  <!-- BEGIN: Search field -->
  <div class="flex items-center col-md-4 relative bg-white rounded-xl py-2">
    <mat-icon svgIcon="search" style="width: 15px; height: 15px;"
              [ngClass]="{'text-primary-500': !isKiosk, 'text-hpc-primary': isKiosk }"
              class="ml-3"></mat-icon>
    <input
      type="text"
      [(ngModel)]="searchKey"
      (ngModelChange)="onSearchChange($event)"
      placeholder="Search"
      [ngClass]="{'text-primary-500': !isKiosk, 'text-hpc-primary': isKiosk }"
      class="focus:outline-none mx-3">

  </div>
  <!-- END: Search field -->
</div>

<div [ngClass]="{'tgsd': !isKiosk, 'kiosk': isKiosk }"
     class="custom-table-wrapper">
  <mat-table class="overflow-x-auto" [dataSource]="listData" matSort (matSortChange)="sortChange($event)">
    <ng-container *ngFor="let tableData of objectKeys(columnHeader); let i = index">
      <div
        class="!text-white">
        <ng-container *ngIf="i == 0">
          <!-- SN Column -->
          <ng-container matColumnDef="{{ tableData }}">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ columnHeader[tableData] }}
            </mat-header-cell>
            <mat-cell class="intro-x" [style]="{'--order': i/8, 'opacity': 0}" *matCellDef="let element; let i = index">
              <span class="column-title" [innerHTML]="columnHeader[tableData]"></span>
              {{ i + 1 + myPaginator.pageIndex * myPaginator.pageSize }}
            </mat-cell>
          </ng-container>
          <!-- end of SN Column -->
        </ng-container>

        <ng-container *ngIf="!actionColumn">
          <ng-container *ngIf="i > 0">
            <ng-container matColumnDef="{{ tableData }}">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                @if (translateColumns) {
                  {{ columnHeader[tableData] | async }}
                } @else {
                  {{ columnHeader[tableData] }}
                }
              </mat-header-cell>

              <mat-cell *matCellDef="let element" >
                <span class="column-title" [innerHTML]="columnHeader[tableData]"></span>
                @if (translatableColumns.includes(tableData)) {
                  <div class="flex flex-col">
                    <span [innerHTML]="element[tableData] | language: 'sw' | ellipsis : ellipsisCount "></span>
                    <span class="text-[11px] text-muted" [innerHTML]="element[tableData] | language: 'en' | ellipsis : ellipsisCount "></span>
                  </div>
                } @else {
                  <span [innerHTML]="element[tableData] | ellipsis : ellipsisCount"></span>
                }
              </mat-cell>
            </ng-container>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="actionColumn">
          <ng-container *ngIf="i > 0 && i < objectKeys(columnHeader).length - 1">
            <ng-container matColumnDef="{{ tableData }}">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                @if (translateColumns) {
                  {{ columnHeader[tableData] | async }}
                } @else {
                  {{ columnHeader[tableData] }}
                }
              </mat-header-cell>
              <!--            (click)="viewDetails(element)"-->
              <mat-cell class="intro-x" [style]="{'--order': i/8, 'opacity': 0}" *matCellDef="let element">
                <span class="column-title" [innerHTML]="columnHeader[tableData]"></span>
                @if (translatableColumns.includes(tableData)) {
                  <div class="flex flex-col">
                    <span [innerHTML]="element[tableData] | language: 'sw' | ellipsis : ellipsisCount "></span>
                    <span class="text-[11px] text-muted" [innerHTML]="element[tableData] | language: 'en' | ellipsis : ellipsisCount "></span>
                  </div>
                } @else {
                  <span [innerHTML]="element[tableData] | ellipsis : ellipsisCount"></span>
                }
              </mat-cell>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="i == objectKeys(columnHeader).length - 1">
            <ng-container matColumnDef="{{ tableData }}">
              <mat-header-cell *matHeaderCellDef mat-sort-header>
                @if (translateColumns) {
                  {{ columnHeader[tableData] | async }}
                } @else {
                  {{ columnHeader[tableData] }}
                }
              </mat-header-cell>
              <mat-cell class="intro-x" [style]="{'--order': i/8, 'opacity': 0}" *matCellDef="let row">
                <span class="column-title" [innerHTML]="columnHeader[tableData]"></span>
                <span class="column-action d-flex justify-content-between">
                <div>
                  <ng-container [ngTemplateOutlet]="actions" [ngTemplateOutletContext]="{ data: row }"></ng-container>
                </div>
                <div class="action-icons px-1">
                  <ng-container *ngIf="hasCheckBoxColumn">
                    <mat-checkbox class="icon-holder" (change)="$event ? selection.toggle(row) : null" (click)="$event.stopPropagation()" [checked]="selection.isSelected(tableData)"></mat-checkbox>
                  </ng-container>
                </div>
              </span>
              </mat-cell>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>

    <!-- Table Configurations -->
    <mat-header-row *matHeaderRowDef="objectKeys(columnHeader)"></mat-header-row>


    <mat-row *matRowDef="let row; columns: objectKeys(columnHeader)"></mat-row>
    <!-- end of Table Configurations -->

    <!-- If No Data Found -->
    <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{ hide: !(listData != null && listData.data.length == 0) }"></mat-footer-row>
    <ng-container matColumnDef="noData">
      <mat-footer-cell *matFooterCellDef colspan="8">No Data</mat-footer-cell>
    </ng-container>
    <!-- end if no Data Found -->

    <!-- Loading Data Message -->
    <mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{ hide: listData != null }"></mat-footer-row>
    <ng-container matColumnDef="loading">
      <mat-footer-cell *matFooterCellDef colspan="8">Loading ...</mat-footer-cell>
    </ng-container>
    <!-- end of Loading Data Message -->
  </mat-table>

 <div class="mt-2" [hidden]="hidePaginator">
  <mat-paginator  #myPaginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" showFirstLastButtons (page)="handlePage($event)" [length]="dataLength"></mat-paginator>
 </div>
</div>
